import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from "../../auth/auth.service";
import { HttpStatusCode } from "../meta/http-status-code.enum";

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO: Only use the token. "this.authService.user.token"
    // TODO: Use Bearer scheme (as recomended by jwt and community) `Bearer ${this.authService.user.token}`
    // NOTE: Token Verification is a form of Authentication; not authorization.

    // AWS S3 presigned URLs carry their own auth in the query string and must be
    // sent exactly as signed. Attaching any extra header breaks the upload (S3
    // responds 400). Detect S3 robustly: regional / virtual-hosted endpoints look
    // like "<bucket>.s3.<region>.amazonaws.com" and do NOT contain the literal
    // "s3.amazonaws.com", so match the domain and the presigned query params.
    const isS3Request = /amazonaws\.com/i.test(req.url) || /[?&]X-Amz-/i.test(req.url);

    // file/download is proxied through our own API even though the URL may mention S3.
    if (isS3Request && !req.url.includes("api/file/download")) {
      return next.handle(req).pipe(
        tap(
          event => { },
          error => { }
        )
      );
    }

    let requestToUse = req;
    const authToken = JSON.stringify(this.authService.user);
    if (!req.url.includes("api/documenthighlights")) {
      requestToUse = req.clone({ headers: req.headers.set("reveleer-legacy-auth", authToken) });
    }
    if (req.url.includes("communicationservice")) {
      requestToUse = req.clone({
        responseType: "text" });
    }

    return next.handle(requestToUse).pipe(
      tap(
        event => { },
        error => {
          if (error instanceof HttpErrorResponse) {
            switch (error.status) {
              case HttpStatusCode.InvalidToken:
                this.authService.logout();
                break;
              default:
                // do nothing;
                break;
            }
          }
        }
      )
    );
  }
}
